// extracted by mini-css-extract-plugin
export default {"container":"WidgetStatPayments_container__ADId1","block-title":"WidgetStatPayments_block-title__obak0","item-input":"WidgetStatPayments_item-input__deKCD"};